import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { PipesModule } from "../../pipes/pipes.module";
import { MaterialModule } from "../../components/material/material.module";
import { TelefonoModule } from "../../components/telefono/telefono.module";
import { AutorizadorModule } from "../../components/autorizador/autorizador.module";
import { ContactoService } from "../../providers/contacto.service";
import { VerFlujosTrabajoComponent } from "./ver-flujos-trabajo/ver-flujos-trabajo.component";
import { PropuestasService } from "../../providers/propuestas.service";
import { FlujoTrabajoComponent } from "./flujo-trabajo/flujo-trabajo.component";
import { CrearFlujoTrabajoComponent } from "./crear-flujo-trabajo/crear-flujo-trabajo.component";
import { CrearFlujoTrabajoDialog } from "./crear-flujo-trabajo/crear-flujo-trabajo-dialog/crear-flujo-trabajo-dialog.component";
import { EliminarFlujoTrabajoComponent } from "./eliminar-flujo-trabajo/eliminar-flujo-trabajo.component";
import { EliminarFlujoTrabajoDialog } from "./eliminar-flujo-trabajo/eliminar-flujo-trabajo-dialog/eliminar-flujo-trabajo-dialog.component";
import { EditarFlujoTrabajoComponent } from "./editar-flujo-trabajo/editar-flujo-trabajo.component";
import { EditarFlujoTrabajoDialog } from "./editar-flujo-trabajo/editar-flujo-trabajo-dialog/editar-flujo-trabajo-dialog.component";
// import { VerContactosComponent } from "./ver-contactos/ver-contactos.component";
// import { CrearContactoComponent } from "./crear-contacto/crear-contacto.component";
// import { CrearContactoDialog } from "./crear-contacto/crear-contacto-dialog/crear-contacto-dialog.component";
// import { ContactoComponent } from "./contacto/contacto.component";
// import { EditarContactoComponent } from "./editar-contacto/editar-contacto.component";
// import { EditarContactoDialog } from "./editar-contacto/editar-contacto-dialog/editar-contacto-dialog.component";
// import { EliminarContactoComponent } from "./eliminar-contacto/eliminar-contacto.component";
// import { EliminarContactoDialog } from "./eliminar-contacto/eliminar-contacto-dialog/eliminar-contacto-dialog.component";
// import { AsignarContactoComponent } from "./asignar-contacto/asignar-contacto.component";
// import { AsignarContactoDialog } from "./asignar-contacto/asignar-contacto-dialog/asignar-contacto-dialog.component";


@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        MaterialModule,
        TelefonoModule,
        AutorizadorModule,
    ],
    declarations: [
        CrearFlujoTrabajoComponent,
        CrearFlujoTrabajoDialog,
        // OrdenEstadoPropuestaDialog,
        EditarFlujoTrabajoComponent,
        EditarFlujoTrabajoDialog,
        EliminarFlujoTrabajoComponent,
        // AsignarContactoComponent,
        EliminarFlujoTrabajoDialog,
        // AsignarContactoDialog,
        FlujoTrabajoComponent,
        VerFlujosTrabajoComponent
    ],
    providers: [
        PropuestasService
    ],
    entryComponents: [
        CrearFlujoTrabajoDialog,
        EditarFlujoTrabajoDialog,
        EliminarFlujoTrabajoDialog,
        // AsignarContactoDialog,
        // OrdenEstadoPropuestaDialog,
    ],
    exports: [
        CrearFlujoTrabajoComponent,
        EditarFlujoTrabajoComponent,
        EliminarFlujoTrabajoComponent,
        // AsignarContactoComponent,
        FlujoTrabajoComponent,
        VerFlujosTrabajoComponent
    ]
})
export class FlujoTrabajoModule { }